import socket from './socketio.js'

export const emit = async <T>(event: string, ...args: any[]): Promise<T> => {
    return new Promise<T>((resolve, reject) => {
        socket.emit(event, localStorage.mtoken, ...args, (err?: string | Error, data?: T) => {
            if (err) {
                reject(typeof err === 'string' ? new Error(err) : err)
            } else {
                resolve(data)
            }
        })
    })
}
